export default "__VITE_ASSET__CXnQnAt6__"